import * as actionTypes from './actionTypes';

const defaultCouponData = {
  couponCode: null,
};

const initialState = {
  allData: [],
  couponData: defaultCouponData,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_NEW_DENOMINATION:
      state = {
        ...state,
        allData: action.payload,
      };
      break;
    case actionTypes.ADD_NEW_DENOMINATION:
      state = {
        ...state,
        allData: [...state.allData, action.payload],
      };
      break;
    case actionTypes.REMOVE_AN_DENOMINATION:
      state = {
        ...state,
        allData: state.allData.filter(
          (denomination) => denomination.AMOUNT !== action.payload.AMOUNT
        ),
      };
      break;
    case actionTypes.UPDATE_QUANTITY_DENOMINATION:
      state = {
        ...state,
        allData: state.allData.map((denomination) => {
          if (String(denomination.AMOUNT) === String(action.payload.AMOUNT)) {
            const quantity = Number(action.payload.QUANTITY) || 0;

            return {
              ...denomination,
              QUANTITY: quantity,
            };
          }
          return denomination;
        }),
      };
      break;
    case actionTypes.SET_COUPON_DATA:
      state = {
        ...state,
        couponData: {
          ...state.couponData,
          ...action.payload,
        },
      };
      break;
    case actionTypes.COUPOUN_CODE_INPUT:
      state = {
        ...state,
        couponData: {
          ...state.couponData,
          couponCode: action.payload,
        },
      };
      break;
    case actionTypes.COUPOUN_STATUS_UPDATE:
      state = {
        ...state,
        couponData: {
          ...state.couponData,
          ...action.payload,
        },
      };
      break;
    case actionTypes.COUPOUN_APPLIED_RESET:
      state = {
        ...state,
        couponData: {
          ...state.couponData,
          isCouponApplied: false,
        },
      };
      break;
    case actionTypes.COUPOUN_CLEAR:
      state = {
        ...state,
        couponData: {
          ...state.couponData,
          couponCode: null,
          isCouponApplied: false,
        },
      };
      break;
    case actionTypes.WIPE_OUT_DENOMINATION:
      state = { allData: [], couponData: defaultCouponData };
      break;
    default:
      state = { ...state };
  }
  return state;
};

export default reducer;
